import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './CockpitNavigatorTreeRow.module.scss'

interface IProps {
  label: ReactNode
  description?: ReactNode
  count: ReactNode
  depth: number
  selected: boolean
  expandable: boolean
  expanded: boolean
  toggleTitle: string
  onToggle: () => void
  onSelect: () => void
}

export const CockpitNavigatorTreeRow = ({
  label,
  description,
  count,
  depth,
  selected,
  expandable,
  expanded,
  toggleTitle,
  onToggle,
  onSelect,
}: IProps) => (
  <div
    className={cn(styles.row, { [styles.selected]: selected })}
    style={{ paddingLeft: `${4 + depth * 16}px` }}
  >
    {expandable ? (
      <button type="button" className={styles.toggle} title={toggleTitle} onClick={onToggle}>
        <i className={cn('kbase', expanded ? 'kbase-chevron-bottom' : 'kbase-chevron-right')} />
      </button>
    ) : (
      <span className={styles.toggle} />
    )}
    <button type="button" className={styles.label} onClick={onSelect}>
      {description ? (
        <span className={styles.caption}>
          <span className={styles.name}>{label}</span>
          <span className={styles.description}>{description}</span>
        </span>
      ) : (
        <span className={styles.name}>{label}</span>
      )}
      <span className={styles.count}>{count}</span>
    </button>
  </div>
)
